import React from 'react';
import { CheckmarkStroke } from '@bloomberg/media-ui-icons';

import { CloseReason, Toast } from '../Toast';
import type { GlobalProps } from '../types';
import { classes } from '../utils';

import styles from './styles.module.css';

export type ToastSuccessProps = GlobalProps & {
  open: boolean;
  text: string;
  autoHideDuration?: number;
  inline?: boolean;
  onClose?: (reason: CloseReason) => void;
};

export const ToastSuccess = React.forwardRef<HTMLDivElement, ToastSuccessProps>(
  function ToastSuccessComponent(props: ToastSuccessProps, ref) {
    const {
      className,
      name = 'toast-success',
      open,
      text,
      autoHideDuration,
      unstyled,
      inline = false,
      onClose,
    } = props;

    const cx = classes([className, styles.toastSuccess], {
      ...props,
      unstyled,
      name,
    });

    return (
      <Toast
        autoHideDuration={autoHideDuration}
        Icon={<CheckmarkStroke className={styles.toastSuccessIcon} />}
        className={cx}
        maxSize="full"
        name={name}
        open={open}
        onClose={onClose}
        position={{
          horizontal: 'center',
          vertical: 'bottom',
        }}
        ref={ref}
        variant="message"
        inline={inline}
      >
        {text}
      </Toast>
    );
  }
);
